import paths from '../../../config/local/paths';
import { translate } from '../../Internationalization';

export const PROPERTY_SCOPED_NAV_ITEMS = [
	{
		key: 'market',
		label: translate(
			'homeowner.pages.properties.scoped.submenu.market_valuation'
		),
		path: paths.app.homeowner.properties.scoped.marketValuation,
	},
	{
		key: 'finances',
		label: translate('homeowner.pages.properties.scoped.submenu.finances'),
		path: paths.app.homeowner.properties.scoped.finances,
	},
	{
		key: 'details',
		label: translate('homeowner.pages.properties.scoped.submenu.details'),
		path: paths.app.homeowner.properties.scoped.details,
	},
	{
		key: 'documents',
		label: translate('homeowner.pages.properties.scoped.submenu.documents'),
		path: paths.app.homeowner.properties.scoped.documents,
	},
	{
		key: 'appliances',
		label: translate(
			'homeowner.pages.properties.scoped.submenu.appliances'
		),
		path: paths.app.homeowner.properties.scoped.appliances,
	},
	{
		key: 'team',
		label: translate('homeowner.pages.properties.scoped.submenu.team'),
		path: paths.app.homeowner.properties.scoped.team,
	},
];

/**
 * @param {boolean} hasTeam
 * @returns {typeof PROPERTY_SCOPED_NAV_ITEMS}
 */
export function getPropertyScopedNavItems(hasTeam) {
	return hasTeam
		? PROPERTY_SCOPED_NAV_ITEMS
		: PROPERTY_SCOPED_NAV_ITEMS.filter((item) => item.key !== 'team');
}

/**
 * @param {string} path
 * @param {string} propertyId
 * @returns {string}
 */
export function resolvePropertyPath(path, propertyId) {
	return path.replace(':propertyId', propertyId);
}
